module.exports = __webpack_public_path__ + "img/1465127635.4a05bfff.jpg";